/**
 * @desc 邮件消息列表
 */
const URL = "/rantion-crm";
import http, { updateResponse } from "@/http";
export function request(params: API.crm.mailMessage.pageList.Params, options?: any) {
  return updateResponse(
    http(URL + `/crm/mailMessage/page/list`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
